<script setup>
definePageMeta({
  auth: false,
});

const { data: upcomingWebinars, status: upcomingStatus } = usePublicFetch(
  "webinars",
  {
    method: "GET",
    key: "upcoming-webinars",
    queryKey: "upcoming-webinars",
    query: {
      status: "upcoming",
    },
    transform(webinars) {
      return webinars?.data;
    },
  },
);

const { data: previousWebinars } = usePublicFetch("webinars", {
  method: "GET",
  key: "previous-webinars",
  queryKey: "previous-webinars",
  query: {
    status: "previous",
  },
  transform(webinars) {
    return webinars?.data;
  },
});

const isHaveWebinars = computed(() => {
  return (
    upcomingWebinars?.value?.length > 0 ||
    previousWebinars?.value?.length > 0 ||
    upcomingStatus.value !== "loading"
  );
});

// --- SEO ---
useHead({
  link: [{ rel: "canonical", href: "https://unilinks.co/webinars" }],
});

useSeoMeta({
  title: "Free Webinars on Thai Education, Visas & Scholarships | UniLinks",
  ogTitle: "Free Webinars on Thai Education, Visas & Scholarships | UniLinks",
  description:
    "Join live webinars on study abroad topics like Thai student visas, education visa processes, and finding the best universities and scholarships in Thailand.",
  ogDescription:
    "Join live webinars on study abroad topics like Thai student visas, education visa processes, and finding the best universities and scholarships in Thailand.",
  ogImage: META_IMAGE_URL,
  ogUrl: "https://unilinks.co/webinars",
  twitterCard: "summary_large_image",
  twitterTitle:
    "Free Webinars on Thai Education, Visas & Scholarships | UniLinks",
  twitterDescription:
    "Join live webinars on study abroad topics like Thai student visas, education visa processes, and finding the best universities and scholarships in Thailand.",
  twitterImage: META_IMAGE_URL,
});
</script>

<template>
  <NuxtLayout name="primary">
    <div class="bg-gray-50">
      <div class="mx-auto lg:w-[1260px] w-full px-4 py-8 mb-12">
        <WebinarBanner
          v-if="upcomingWebinars?.length > 0"
          :webinar="upcomingWebinars?.at(0)"
        />
        <img
          v-else
          src="~/assets/img/webinar-banner-dummy.png"
          alt="webinar-banner-dummy"
          class="w-full object-cover rounded-md"
        />

        <div
          v-if="!isHaveWebinars"
          class="min-h-[300px] sm:min-h-[400px] lg:min-h-[500px] flex items-center justify-center"
        >
          <div class="text-center space-y-6 max-w-md lg:max-w-lg px-4">
            <img
              src="~/assets/img/icon/cloud-search.svg"
              alt="search"
              class="mx-auto w-24 h-24 sm:w-28 sm:h-28 lg:size-32"
            />
            <h2 class="text-xl sm:text-2xl font-semibold text-surface-900">
              Discover New Opportunities!
            </h2>
            <p class="text-surface-600 text-sm sm:text-base">
              Webinars aren't available yet, but you can still explore programs
              that match your interests and take the next step toward your dream
              university!
            </p>
            <Button
              label="Explore Programs Now"
              icon="pi pi-search"
              class="px-4"
              @click="navigateTo('/explore')"
            />
          </div>
        </div>

        <Tabs value="upcoming" class="mt-10" v-else>
          <TabList>
            <Tab value="upcoming">Upcoming</Tab>
            <Tab value="previous">Previous</Tab>
          </TabList>
          <TabPanels class="py-6">
            <TabPanel value="upcoming">
              <div
                class="h-40 flex items-center justify-center"
                v-if="upcomingWebinars?.length === 0"
              >
                <p class="text-center text-muted text-sm">
                  No upcoming webinars at the moment. Stay tuned for future
                  events!
                </p>
              </div>
              <UpcomingWebinars />
            </TabPanel>
            <TabPanel value="previous">
              <div
                class="h-40 flex items-center justify-center"
                v-if="previousWebinars?.length === 0"
              >
                <p class="text-center text-muted text-sm">
                  No previous webinars at the moment.
                </p>
              </div>
              <PreviousWebinars />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </div>
    <Footer />
  </NuxtLayout>
</template>
